"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveDefaultsModeConfig = void 0;
var config_1 = require("@smithy/core/config");
Object.defineProperty(exports, "resolveDefaultsModeConfig", { enumerable: true, get: function () { return config_1.resolveDefaultsModeConfig; } });
